import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { SearchGroupTemplatesState } from '../reducers/search-group-templates.reducer';
import * as selectors from '../selectors/search-group-templates.selectors';

@Injectable({ providedIn: 'root' })
export class SearchGroupTemplatesFacadeService extends FacadeService {
  constructor(public override store: Store<SearchGroupTemplatesState>) {
    super(store);
  }

  // OBSERVABLES

  panelExpandedValue$ = this.storeSelect(selectors.getPanelExpandedValue);
  code$ = this.storeSelect(selectors.getCode);
  remarks$ = this.storeSelect(selectors.getRemarks);
  inactive$ = this.storeSelect(selectors.getInactive);
  updateGroupTemplateRoleExist$ = this.storeSelect(selectors.getUpdateGroupTemplateRoleExist);
  createNewGroupTemplateBtnEnabled$ = this.storeSelect(selectors.getCreateNewGroupTemplateBtnEnabled);

  // OBSERVABLE'S VALUES

  get panelExpandedValue() {
    return this.storeSnapshot(this.panelExpandedValue$);
  }

  get code() {
    return this.storeSnapshot(this.code$);
  }

  get remarks() {
    return this.storeSnapshot(this.remarks$);
  }

  get inactive() {
    return this.storeSnapshot(this.inactive$);
  }

  get createNewGroupTemplateBtnEnabled() {
    return this.storeSnapshot(this.createNewGroupTemplateBtnEnabled$);
  }
}
